import { useMutation, useQueryClient } from "@tanstack/react-query";
import templateRepository from "@/repository/templateRepository";
import { scenarioQueryKeys } from "@/query/scenario";
import { templateKeys } from "./keys";


export const useDeleteTemplate = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationFn: async (templateId: number) => {
            await templateRepository.delete(scenarioId, templateId);
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: templateKeys.all(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.autocompletes(scenarioId) })
            ]);
        }
    });
};
